import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { of, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../store/states/app.state';
import { selectTenant } from '../store/selectors/tenant.selector';
import { map } from 'rxjs/internal/operators/map';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  backend_url: string;
  constructor(public http?: HttpClient, public store?: Store<AppState>) {
  }

  readonly uris = {};

  getInitUrl(uri: string, withAPIVersion: boolean = true) {
    return `${environment.api.initBase}/${withAPIVersion ? `api/${environment.api.version}/` : ''
      }${uri}`;
  }

  getUrl(uri: string, withAPIVersion: boolean = true) {
    if (this.store) {
      this.store
        .select(selectTenant)
        .pipe(take(1))
        .subscribe(tenant => {
          if (tenant?.backend_url) {
            this.backend_url = `${environment.api.protocol}://${tenant.backend_url}`;
          }
        });
    }
    const base = environment.api.initBase ?? environment.api.base;
    return `${base}/${withAPIVersion ? `api/${environment.api.version}/` : ''}${uri}`;
  }

  getParamsFromObject(object: any): HttpParams {
    return object
      ? Object.keys(object)
        .map(key => ({ key, value: object[key] }))
        .reduce((params, { key, value }) => {
          return params.set(key, value);
        }, new HttpParams())
      : null;
  }

  readAsBlob(url: string): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob'
    });
  }

  /** Network/API errors propagate as null; no localStorage fallback (avoids stale catalog). */
  cacheHandler(err: Error, _key: string) {
    if (err instanceof HttpErrorResponse && err.status === 0) {
      return of(null);
    }
    return of(null);
  }
}
